import { render, staticRenderFns } from "./WordPopNew.vue?vue&type=template&id=7c8bed9a&scoped=true&"
import script from "./WordPopNew.vue?vue&type=script&lang=js&"
export * from "./WordPopNew.vue?vue&type=script&lang=js&"
import style0 from "./WordPopNew.vue?vue&type=style&index=0&id=7c8bed9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c8bed9a",
  null
  
)

export default component.exports